<template>
  <div class="ref-control-box">
    <span class="text" @click="openDialog">{{ list[0].title }}</span>
    <detail-dialog
      :visible.sync="dialogVisible"
      :data-id="list[0].id"
      :app-id="refSheetAppId"
    ></detail-dialog>
  </div>
</template>

<script>
import { getAppIdInAvailableSheets } from "@/utils/sheet"
import { getAvailableSheets } from "@/api/sheet/sheet"
export default {
  name: "RefControl",
  props: {
    control: Object,
    list: Array
  },
  inject: ["dataInfo"],
  data() {
    return {
      dialogVisible: false,
      refSheetAppId: ""
    }
  },
  beforeCreate() {
    this.$options.components.DetailDialog = require("@/components/Sheet/DetailDialog").default
  },
  created() {
    this.initRefSheetAppId()
  },
  methods: {
    initRefSheetAppId() {
      getAvailableSheets({ appId: this.dataInfo.appId }).then(availableSheets => {
        this.refSheetAppId = getAppIdInAvailableSheets(availableSheets, this.control.refSheetId)
      })
    },
    openDialog() {
      this.dialogVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
.ref-control-box {
  .text {
    color: $color-main;
    cursor: pointer;
  }
}
</style>
